import moment, {Moment} from 'moment';

export const getDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = {day: 'numeric', month: 'short', year: 'numeric'};
    return date.toLocaleDateString('en-US', options);
};

export const getDateTime = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };
    return date.toLocaleTimeString('en-US', options);
};
export const getReportDateTime = (date) => {
    if (typeof date === 'string') {
        return moment.utc(date).hour(0).minute(0).second(0);
    }
    return moment.utc(date.format('YYYY-MM-DD')).hour(0).minute(0).second(0);
}
export const getDateAsStr = (date,format="DD MMM YYYY") => {
    if (!date) {
        return '';
    }

    if (typeof date.setSeconds !== "undefined") {
        return moment.utc(date.getUTCFullYear() + '-' + date.getMonth() + '-' + date.getDate(), 'YYYY-MM-DD').format("DD MMM YYYY")
    }
    if (typeof date === 'string') {
        return moment.utc(date).format(format)
    }
    return date.format(format)
}
export const formatDateTime = (date) => {
    if (date) {
        return moment(date).format("DD MMM YYYY H:mm")
    }
    return '';
}
export const getTimeStr = (date) => {
    if (date) {
        return moment(date).format("H:mm")
    }
    return '';
}
export const stripTime = (date) => {
    if (typeof date === 'string') {
        return date
    }
    return moment.utc(date.format('YYYY-MM-DD')).hour(0).minute(0).second(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss');

}
export const getTimeSlots = (start, end, interval = 1) => {
    var startTime = moment(start, 'HH:mm:ss');
    var endTime = moment(end, 'HH:mm:ss');

    if (endTime.isBefore(startTime)) {
        endTime.add(1, 'day');
    }

    var timeStops = [];

    while (startTime < endTime) {
        timeStops.push(new moment(startTime).format('H:mm'));
        startTime.add(1, 'hour');
    }
    return timeStops;
}
export const getTimeDiff = (start_time, end_time) => {

    let timeStart = new Date("01/01/2007 " + start_time).getHours();
    let timeEnd = new Date("01/01/2007 " + end_time).getHours();

    let hourDiff = timeEnd - timeStart;
    if (hourDiff < 0) {
        hourDiff = 24 + hourDiff;
    }
    return hourDiff;
}
export const getWeekNumber = (date) => {

    if (!date) {
        return ''
    }
    if (typeof date === 'string') {
        date = moment.utc(date);
        return `Week ${Math.ceil(date.date() / 7)} of ${date.format('MMM YYYY')}`
    }

    return "Week " + Math.ceil(date.date() / 7) +
        " of MMM YYYY"
}
export const getMaxDateForDashboard=(dates)=>{

    Object.keys(dates).forEach((k) => dates[k] === "" && delete dates[k]);

    if (Object.keys(dates).length > 0) {
        let moments = Object.values(dates).map(d => moment(d));
        return moment.max(moments);
    }
    return null;
}


export const getTimeznDate = (dateValue, format="YYYY-MM-DDTHH:mm:ss", day_substract = 0) =>{
    const options = {day: 'numeric', month: 'numeric', year: 'numeric'};
    const date = new Date(dateValue).toLocaleDateString('en-US', options);
    if (day_substract != 0){
        return moment(date, 'MM/DD/YYYY').subtract(day_substract, 'days').format(format);
    }
    return moment(date, 'MM/DD/YYYY').format(format);
    };

export const getTommorowTimeznDate = (dateValue, format="YYYY-MM-DDTHH:mm:ss", day_add = 0) =>{
        const options = {day: 'numeric', month: 'numeric', year: 'numeric'};
        const date = new Date(dateValue).toLocaleDateString('en-US', options);
        if (day_add != 0){
            return moment(date, 'MM/DD/YYYY').add(day_add, 'days').format(format);
        }
        return moment(date, 'MM/DD/YYYY').format(format);
        };

export const formatDate = (dateValue, from_format = "DD-MM-YYYY", to_format="DD MMM YYYY") =>{
    const options = {day: 'numeric', month: 'numeric', year: 'numeric'};
    if (dateValue === "string")
        dateValue = new Date(dateValue, from_format).toLocaleDateString('en-US', options);
    return moment(dateValue).format(to_format);
    };

export const stringToDate = (dateValue, from_format = "DD-MM-YYYY", ) =>{
        if (dateValue === "string")
            dateValue = new Date(dateValue, from_format)
        return moment(dateValue);
        };